import { makeAutoObservable, toJS } from "mobx";
import { apiGet, apiPostPut } from "../api/api_methods";

class LearningStore {
  constructor() {
    makeAutoObservable(this);
  }

  hittedApis = {
    courseList: false,
    currentCourse: false,
    enrolledCourses: false,
  };

  completesubTopic = {};
  currentCourse = null; // current course of object
  topics = []; // all courses will list here
  currentCourseId = null; // thisi the current course id

  currentSubTopic = null; // current subtopic of object
  allSubTopics = [];
  loading = false;

  courseList = []; // all courses will list here

  enrolledCourses = []; // all courses of user will list here
  userId = null;

  // recentlyEnrolledId = [];

  setallSubtopics = (topics) => {
    this.allSubTopics = topics;
  };

  setUserId = (id) => {
    this.userId = id;
  };

  updateCompletedTopicsInEnrolledCourses = (courseId, completedTopicsArray) => {
    const index = this.enrolledCourses.findIndex(
      (enroll) => enroll?.course._id == courseId
    );
    if (index > -1) {
      this.enrolledCourses[index].completedTopics = completedTopicsArray;
      console.log(toJS(this.enrolledCourses));
    }
  };

  checkTopicCompleted = (courseId, topicId) => {
    const index = this.enrolledCourses.findIndex(
      (enroll) => enroll?.course._id == courseId ?? this.currentCourseId
    ); // to check if the course is enrolled or not

    console.log(index);

    if (index > -1) {
      const topicIndex = this.enrolledCourses[index].completedTopics.findIndex(
        (completedTopics) =>
          completedTopics.topicId == topicId ?? this.currentSubTopic?._id
      );
      console.log(topicIndex);
      if (topicIndex > -1) {
        return true;
      }
      return false;
    }

    return false;
  };

  getTheLastCompletedSubTopic = (courseId) => {
    const index = this.enrolledCourses.findIndex(
      (enroll) => enroll?.course._id == courseId ?? this.currentCourseId
    ); // to check if the course is enrolled or not

    console.log(index);
    if (index > -1) {
      console.log(toJS(this.enrolledCourses[index].completedTopics));

      const completedTopics = this.enrolledCourses[index].completedTopics ?? [];
      if (completedTopics.length === 0) return this.allSubTopics[0];
      const lastCompletedSubTopic = completedTopics[completedTopics.length - 1];
      return lastCompletedSubTopic;
    }
  };

  checkShallWeMarkThisTopicAsCompleted = (courseId) => {
    return true; // remove this later

    // this function will check the last completed topic is completed in last 10 min or not
    // if completed in last 10 min then not allow to complete the topic by return false
    const index = this.enrolledCourses.findIndex(
      (enroll) => enroll?.course._id == courseId ?? this.currentCourseId
    ); // to check if the course is enrolled or not

    // console.log(index);
    if (index > -1) {
      // check the last completed topic of the course by using timestamp
      const completedTopics = this.enrolledCourses[index].completedTopics ?? [];
      if (completedTopics.length === 0) return true;
      let lastCompletedTopic = [];

      // 300000 - 5 min
      // 600000 - 10 min

      const last10MinTimeStamp = Date.now() - 300000;
      // const last10MinTimeStamp = Date.now()  // for testing purpose

      completedTopics.forEach((topic) => {
        // this loop will check the last completed topic is completed in last 10 min or not
        if (topic.createdAt > last10MinTimeStamp) {
          // console.log(toJS(topic));
          lastCompletedTopic.push(topic);
        }
      });
      // console.log(lastCompletedTopic);
      if (lastCompletedTopic.length > 0)
        return false; // last topic is completed in last 9 min so not allow to complete the topic
      else return true; // last topic completed 10 min ago so allow to complete the topic
    }
    return false;
  };

  async completeCurrentSubTopic(subTopicId) {
    if (!this.checkShallWeMarkThisTopicAsCompleted(this.currentCourse?._id)) {
      console.log("not allowed to complete the topic");
      return false;
    }

    // this.setLoading();
    const body = {
      userId: this.userId,
      courseId: this.currentCourse?._id,
      topic: subTopicId ?? this.currentSubTopic._id,
    };
    // this.setLoading();
    const response = await apiPostPut(body, `/enroll/topic-completed`, "POST");
    // this.setLoading(false);
    if (response.status === 200) {
      console.log(response?.body);
      this.setCompleteSubTopic(response?.body);
      this.updateCompletedTopicsInEnrolledCourses(
        this.currentCourse?._id,
        response?.body?.data?.completedTopics
      );
      return true;
    } else {
      alert(response?.body?.message);
      return false;
    }
  }

  setCompleteSubTopic = (subTopic) => {
    this.completesubTopic = subTopic;
  };

  checkCourseEnrolled = (courseId) => {
    console.log(courseId);
    console.log(toJS(this.enrolledCourses));
    const index = this.enrolledCourses.findIndex(
      (enroll) => enroll?.course._id == courseId
    );

    console.log(index);

    if (index > -1) {
      return true;
    }

    // const index2 = this.recentlyEnrolledId.findIndex(
    //   (id) => id == courseId
    // );
    // if (index2 > -1) {
    //   return true;
    // }

    return false;
  };

  getTheCourseCompletionPercentage = (courseId) => {
    const isEnrolled = this.checkCourseEnrolled(courseId);
    if (isEnrolled) {
      const index = this.enrolledCourses.findIndex(
        (enroll) => enroll?.course._id == courseId
      );
      const completedTopics = this.enrolledCourses[index].completedTopics ?? [];
      const totalTopics = this.enrolledCourses[index]?.totalTopics;
      const percentage = ((completedTopics.length / totalTopics) * 100).toFixed(
        0
      );
      const finalPercentage = percentage <= 100 ? percentage : 100
      return finalPercentage;
    }
    return 0;
  };

  getCourseCompletionDate = (courseId) => {
    const isEnrolled = this.checkCourseEnrolled(courseId);
    if (isEnrolled) {
      const index = this.enrolledCourses.findIndex(
        (enroll) => enroll?.course._id == courseId
      );
      const completedTopics = this.enrolledCourses[index].completedTopics ?? [];
      const totalTopics = this.enrolledCourses[index]?.totalTopics;
      // const isCompleted = completedTopics.length >= totalTopics;
      // if (isCompleted) {
      const lastCompletedTopic = completedTopics[completedTopics.length - 1];
      const date = lastCompletedTopic?.createdAt;
      return date;
      // }
      return "Not Completed";
    }
  };

  getTheTotalTopics = (courseId) => {
    const isEnrolled = this.checkCourseEnrolled(courseId);
    if (isEnrolled) {
      const index = this.enrolledCourses.findIndex(
        (enroll) => enroll?.course._id == courseId
      );
      const totalTopics = this.enrolledCourses[index]?.totalTopics;
      return totalTopics;
    }
    return 0;
  };

  setEnrolledCourses = (courses) => {
    console.log(toJS(courses));
    this.enrolledCourses = courses;
  };

  setLoading = (value) => {
    this.loading = value ?? true;
  };

  async getEnrolledCoursesFromServer(userId, refresh = false) {
    if (!userId) return null;
    this.setUserId(userId);
    // if (this.enrolledCourses && !refresh) return;
    // this.hittedApis.enrolledCourses = true;
    this.setLoading();
    const response = await apiGet(`/enroll/user-enrolled-courses/${userId}`);
    this.setLoading(false);
    if (response.status === 200) {
      console.log(response?.body?.data);
      return this.setEnrolledCourses([...response?.body?.data]);
    } else {
      return alert("something went wrong");
    }
  }

  async enrollForCourse(courseId, userId) {
    const body = {
      userId: userId ?? this.userId,
      course: courseId,
    };
    this.setLoading();
    const response = await apiPostPut(body, `/enroll/create`, "POST");
    this.setLoading(false);
    if (response.status === 200) {
      // this.recentlyEnrolledId.push(courseId);
      // this.setEnrolledCourses([...this.enrolledCourses, response?.body?.data]);
      console.log(response?.body?.data);
      this.getEnrolledCoursesFromServer(body.userId, true);
      return true;
    } else {
      alert(response?.body?.message);
      return false;
    }
  }

  async getCourseListFromApi(refresh = false) {
    if (this.hittedApis.courseList && !refresh) return;
    this.hittedApis.courseList = true;
    this.setLoading();
    const response = await apiGet("/course/all-courses");
    this.setLoading(false);
    if (response.status === 200) {
      console.log(response?.body?.data);
      return this.setCourseList([...response?.body?.data]);
    } else {
      return alert("something went wrong");
    }
  }

  setCourseList = (courses) => {
    console.log(toJS(courses));
    this.courseList = courses;
  };
  setCurrentCourseId(id) {
    this.currentCourseId = id;
  }

  nextSubTopic(SubTopicId) {
    let index = this.allSubTopics.findIndex(
      (subtopic) => subtopic._id === SubTopicId
    );
    if (index < this.allSubTopics.length - 1) {
      this.currentSubTopic = this.allSubTopics[index + 1];
    }
  }

  getNextSubTopicById(id) {
    let index = this.allSubTopics.findIndex(
      (subtopic) => subtopic._id === id ?? this.currentSubTopic._id
    );
    if (index < this.allSubTopics.length - 1) {
      return this.allSubTopics[index + 1];
    }
  }

  getPrevSubTopicById(id) {
    let index = this.allSubTopics.findIndex(
      (subtopic) => subtopic._id === id ?? this.currentSubTopic._id
    );
    if (index > 0) {
      return this.allSubTopics[index - 1];
    }
  }

  setCurrentCourse(course) {
    this.currentCourse = course;
  }

  setCurrentSubTopicById(id) {
    this.topics.forEach((topic) => {
      topic.subTopics.forEach((subtopic) => {
        if (subtopic._id === id) {
          this.currentSubTopic = subtopic;
        }
      });
    });
  }

  setHittendApis = (key, value) => {
    this.hittedApis[key] = value;
  };

  getCourseFromServer = async (id, topic) => {
    if (this.hittedApis.currentCourse) return;
    this.hittedApis.currentCourse = true;
    this.setLoading();
    const response = await apiGet(`/course/courses/${id}`);
    this.setLoading(false);
    if (response.status === 200) {
      console.log(response?.body?.data);
      this.setCurrentCourse(response?.body?.data);
      this.topics = response?.body?.data?.topics;

      this.allSubTopics = [];
      response?.body?.data?.topics.forEach((topic) => {
        topic.subTopics.forEach((subtopic) => {
          this.allSubTopics.push(subtopic);
        });
      });
      if (topic) {
        this.setCurrentSubTopicById(topic);
      }
    }
  };
}

export default LearningStore;
